var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pb-4",attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{staticClass:"text-subtitle-1 text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('v-col',{attrs:{"cols":"10"}},[_c('progress-spiner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }